<template>
  <div :class='formGroupClass'>
    <label class='control-label'>{{ inputLabel }}</label>
    <input class='form-control' v-model="inputValue" :disabled="isView" @blur="$emit($event.type, $event.target.value)"/>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import ErrorHelpBlock from '@/common/components/application/ErrorHelpBlock.vue';
export default {
  name: 'DocumentNumberInput',
  components: { ErrorHelpBlock },

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputLabel: {
      type: String,
      default: 'Номер документа'
    },
    inputName: {
      type: String,
      default: 'number'
    }
  },

  computed: {
    hasInputErrors () {
      return !!this.errors.number
    },

    actualErrorMessage () {
      if (this.disableErrorBorder) {
        return null
      }

      return this.errors.number
    }
  },

  watch: {
    inputValue() {
      this.clearErrorOnFill = this.hasEmptyFieldError
      this.disableErrorBorder = !!(this.clearErrorOnFill && this.inputValue)
    },

    errors() {
      this.disableErrorBorder = false
    }
  }
}
</script>
